import { render, staticRenderFns } from "./stockLossAction.vue?vue&type=template&id=345fc5dc&scoped=true"
import script from "./stockLossAction.vue?vue&type=script&lang=js"
export * from "./stockLossAction.vue?vue&type=script&lang=js"
import style0 from "./stockLossAction.vue?vue&type=style&index=0&id=345fc5dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345fc5dc",
  null
  
)

export default component.exports